import { styled, Typography } from '@mui/material'

export const TotalText = styled(Typography)`
  height: 100%;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  text-align: right;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: end;
  color: ${({ theme }) => theme.palette.custom.gray2};
`
